module.exports = __webpack_public_path__ + "img/gemFollow.8c0fc688.svg";